import React from 'react';

const WorkTime = ({ currentLanguage = 'KM' }) => {
  const content = {
    KM: {
      title: "ម៉ោងបើកដំណើរការ",
      subtitle: "សូមអញ្ជើញមកកាន់យើងខ្ញុំក្នុងម៉ោងទាំងនេះ",
      location: {
        title: "សាខារបស់យើង",
        branches: [
          {
            name: "សាខាទី១ - SARYDA BEAUTY CLINIC",
            address: "ផ្លូវក្រោយនាគទិព្វ ផ្លូវទៅស្រាផ្ទិល ហួសនាគទិព្វប្រហែល 800 ម៉ែត្រ",
            hours: "9am - 2am (រាល់ថ្ងៃ)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/NrdU6zR31NENcwYq7?g_st=ic"
          },
          {
            name: "សាខាទី២ - The King International spa and clinic",
            address: "ផ្លូវលេខ៣ កំពង់ស្វាយ សិរីសោភ័ណ បន្ទាយមានជ័យ",
            hours: "8:30am - 7pm (រាល់ថ្ងៃ)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/nnrnG8sCVGCD6R2LA?g_st=com.google.maps.preview.copy"
          },
          {
            name: "សាខាទី៣",
            address: "ក្បែរផ្សារទួលគោក, ផ្លូវលេខ 614",
            hours: "9am - 10pm (រាល់ថ្ងៃ)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/U3H9JTn1LfCESJF57"
          }
        ]
      },
      hotline: {
        title: "Hotline ទំនាក់ទំនង",
        phone: "077221295",
        telegram: "@chhanryda",
        telegramLink: "https://t.me/chhanryda"
      },
      hours: [
        { day: "ថ្ងៃច័ន្ទ", time: "9:00 ព្រឹក - 7:00 ល្ងាច", isOpen: true },
        { day: "ថ្ងៃអង្គារ", time: "9:00 ព្រឹក - 7:00 ល្ងាច", isOpen: true },
        { day: "ថ្ងៃពុធ", time: "9:00 ព្រឹក - 7:00 ល្ងាច", isOpen: true },
        { day: "ថ្ងៃព្រហស្បតិ៍", time: "9:00 ព្រឹក - 7:00 ល្ងាច", isOpen: true },
        { day: "ថ្ងៃសុក្រ", time: "9:00 ព្រឹក - 8:00 ល្ងាច", isOpen: true },
        { day: "ថ្ងៃសៅរ៍", time: "10:00 ព្រឹក - 8:00 ល្ងាច", isOpen: true },
        { day: "ថ្ងៃអាទិត្យ", time: "10:00 ព្រឹក - 6:00 ល្ងាច", isOpen: true }
      ],
      note: "ស្វាគមន៍អតិថិជនទាំងអ្នកមកសាកសួរ ប៉ុន្តែគួរតែកក់ទុកជាមុន",
      bookButton: "កក់កាលវិភាគ",
      contactButton: "ទំនាក់ទំនងមកយើង",
      questionText: "មានសំណួរអ្វី? សូមទូរស័ព្ទមក 077221295 ឬផ្ញើសារតាម Telegram: @chhanryda"
    },
    EN: {
      title: "Opening Hours",
      subtitle: "Visit Us During These Hours",
      location: {
        title: "Our Branches",
        branches: [
          {
            name: "Branch 1 - SARYDA BEAUTY CLINIC",
            address: "Behind Nak Tiev, Street to Sra Pidil, about 800m past Nak Tiev",
            hours: "9am - 2am (Everyday)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/NrdU6zR31NENcwYq7?g_st=ic"
          },
          {
            name: "Branch 2 - The King International spa and clinic",
            address: "Street No.3, Kampong Svay, Serei Sophorn, Banteay Meanchey",
            hours: "8:30am - 7pm (Everyday)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/nnrnG8sCVGCD6R2LA?g_st=com.google.maps.preview.copy"
          },
          {
            name: "Branch 3",
            address: "Near Tuol Kok Market, Street 614",
            hours: "9am - 10pm (Everyday)",
            phone: "077221295",
            mapLink: "https://maps.app.goo.gl/U3H9JTn1LfCESJF57"
          }
        ]
      },
      hotline: {
        title: "Hotline Contact",
        phone: "077221295",
        telegram: "@chhanryda",
        telegramLink: "https://t.me/chhanryda"
      },
      hours: [
        { day: "Monday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Tuesday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Wednesday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Thursday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Friday", time: "9:00 AM - 8:00 PM", isOpen: true },
        { day: "Saturday", time: "10:00 AM - 8:00 PM", isOpen: true },
        { day: "Sunday", time: "10:00 AM - 6:00 PM", isOpen: true }
      ],
      note: "Walk-ins welcome, but appointments are recommended",
      bookButton: "Book Appointment",
      contactButton: "Contact Us",
      questionText: "💬 Have questions? Call us at 077221295 or message on Telegram: @chhanryda"
    }
  };

  const currentContent = content[currentLanguage] || content.KM;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Battambang:wght@300;400;500;600;700&display=swap');
        
        .font-inter {
          font-family: 'Inter', 'Battambang', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
      `}</style>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className={`text-3xl md:text-4xl font-bold text-gray-900 mb-3 font-inter`}>
              {currentContent.title}
            </h2>
            <p className={`text-lg text-gray-600 font-inter`}>
              {currentContent.subtitle}
            </p>
          </div>

          {/* Hotline Banner */}
          <div className="mb-8 bg-gradient-to-r from-[#f2c742] to-[#e0b53a] rounded-lg p-4 text-center">
            <div className="flex flex-wrap items-center justify-center gap-4">
              <div className="flex items-center gap-2">
                <svg className="w-6 h-6 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="font-bold text-gray-900">Hotline: {currentContent.hotline.phone}</span>
              </div>
              <a 
                href={currentContent.hotline.telegramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                <span>Telegram: {currentContent.hotline.telegram}</span>
              </a>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            
            {/* Opening Hours */}
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#f2c742] bg-opacity-20 rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-[#f2c742]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 font-inter`}>
                  {currentContent.title}
                </h3>
              </div>

              <div className="space-y-3">
                {currentContent.hours.map((schedule, index) => (
                  <div 
                    key={index}
                    className="flex justify-between items-center py-3 border-b border-gray-200 last:border-b-0"
                  >
                    <span className={`font-semibold text-gray-900 font-inter`}>
                      {schedule.day}
                    </span>
                    <div className="flex items-center">
                      {schedule.isOpen && (
                        <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                      )}
                      <span className={`text-gray-600 font-inter`}>
                        {schedule.time}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 p-4 bg-[#f2c742] bg-opacity-10 rounded-lg border border-[#f2c742] border-opacity-20">
                <p className={`text-sm text-gray-700 font-inter`}>
                  <span className="font-semibold text-[#f2c742]">ℹ️ </span>
                  {currentContent.note}
                </p>
              </div>
            </div>

            {/* Branch Information */}
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#f2c742] bg-opacity-20 rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-[#f2c742]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 font-inter`}>
                  {currentContent.location.title}
                </h3>
              </div>

              <div className="space-y-6">
                {currentContent.location.branches.map((branch, idx) => (
                  <div key={idx} className="border-b border-gray-200 last:border-b-0 pb-4 last:pb-0">
                    <h4 className={`font-bold text-gray-900 mb-2 font-inter`}>
                      {branch.name}
                    </h4>
                    <div className="space-y-2 text-sm">
                      <div className="flex items-start gap-2">
                        <svg className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className="text-gray-600 font-inter">{branch.address}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-gray-600 font-inter">{branch.hours}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        <a 
                          href={`tel:${branch.phone}`}
                          className={`text-[#f2c742] hover:text-[#e0b53a] font-semibold font-inter`}
                        >
                          {branch.phone}
                        </a>
                      </div>
                      <a 
                        href={branch.mapLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-sm text-[#f2c742] hover:text-[#e0b53a] font-semibold mt-1"
                      >
                        📍 មើលផែនទី →
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="mt-6 grid grid-cols-2 gap-3">
                <a 
                  href="tel:077221295"
                  className={`bg-[#f2c742] hover:bg-[#e0b53a] text-gray-900 py-3 rounded-lg font-semibold text-center font-inter transition-colors`}
                >
                  {currentContent.bookButton}
                </a>
                <a 
                  href="https://t.me/chhanryda"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`bg-gray-200 hover:bg-gray-300 text-gray-700 py-3 rounded-lg font-semibold text-center font-inter transition-colors`}
                >
                  {currentContent.contactButton}
                </a>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 bg-white rounded-lg shadow-md p-6 text-center">
            <p className={`text-gray-700 font-inter`}>
              💬 {currentContent.questionText}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default WorkTime;